import ClientHomepageModel from '@models/clientHomepage';
import axiosInstance from '../../utils/http-client';

export const getClientHomepage = (slug: string): Promise<ClientHomepageModel> => {
  return axiosInstance.get(`/api/v1/client/${slug}/homepage`, {});
};

export default getClientHomepage;
